import { Injectable } from '@angular/core';
import { UserLocalStorageService } from '../../shared/services/user-local-storage.service';


@Injectable({ providedIn: 'root' })
export class AuthLifecycleStorageService {
  private _isJustAuthenticated = false;
  private readonly LS_NOT_AUTHENTICATED = 'not-authenticated'

  get isJustAuthenticated(): boolean {
    return this._isJustAuthenticated;
  }

  updateAuthState(isAuthenticated: boolean): void {
    const lastNotAuthState = UserLocalStorageService.getValue(this.LS_NOT_AUTHENTICATED);
    if (!isAuthenticated) {
      UserLocalStorageService.setValue(this.LS_NOT_AUTHENTICATED, 'true');
      this._isJustAuthenticated = false;
    } else {
      UserLocalStorageService.removeValue(this.LS_NOT_AUTHENTICATED);
      this._isJustAuthenticated = lastNotAuthState === 'true';
    }
  }

}
